/**
 * Axios HTTP client
 * - Base URL from env.js
 * - Centralised error handling
 * - Optional auth support
 * - Dev logging
 */

import axios from 'axios'
import { env } from '../config/env'

// Import only if authStore exists in your project
// Otherwise remove this line
import { useAuthStore } from '../store/authStore'

const httpClient = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 600000,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
})

// Request interceptor
httpClient.interceptors.request.use(
  (config) => {
    
    if (env.useAuth) {
      const token = useAuthStore.getState()?.token

      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    if (env.isDev) {
      console.debug(
        `[API →] ${config.method?.toUpperCase()} ${config.url}`,
        config.data ?? ''
      )
    }

    return config
  },
  (error) => Promise.reject(error)
)

// Response interceptor
httpClient.interceptors.response.use(
  (response) => {
    if (env.isDev) {
      console.debug(
        `[API ←] ${response.status} ${response.config.url}`,
        response.data
      )
    }

    return response
  },
  (error) => {
    const status = error.response?.status

    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      error.message ||
      'An unexpected error occurred'

    if (status === 401) {
      window.dispatchEvent(new CustomEvent('auth:expired'))
    }

    return Promise.reject({
      status,
      message,
      raw: error,
    })
  }
)

export default httpClient